// const topTrunkShow = new Swiper("#top-trunk-show", {
//   loop: true,
//   speed: 1000, 
//   autoplay: {
//     delay: 3000, 
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev"
//   },
//   pagination: {
//     el: ".swiper-pagination", 
//     type: "bullets",
//     clickable: "clickable"
//   }
//   });
//   const fraction = new Swiper("#fraction", {
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev"
//   },
//   pagination: {
//     el: ".swiper-pagination", 
//     type: "fraction"
//   }
//   });
//   const progressbar = new Swiper("#progressbar", {
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev"
//   },
//   pagination: {
//     el: ".swiper-pagination",
//     type: "progressbar"
//   }
// });
const topTrunkShow = new Swiper("#top-trunk-show", {
  slidesPerView: 1,
  loop: true,
  centeredSlides : true,
  navigation: {
    nextEl: ".top-trunk-show__button--next",
    prevEl: ".top-trunk-show__button--prev",
  },
  pagination: {
    el: ".top-trunk-show__pagination",
    clickable: true,
  },
  breakpoints: {
    750: {
      slidesPerView: 1.621,
      spaceBetween: 80,
    }
  }
});

const topAbout = new Swiper("#top-about", {
  loop: true,
  allowTouchMove: false,
  navigation: {
    nextEl: ".top-about__button--next",
    prevEl: ".top-about__button--prev",
  },
  pagination: {
    el: ".top-about__pagination",
    type: "fraction",
    formatFractionCurrent: function (number) {
      return '0' + `${number - 1}`;
    },
    formatFractionTotal: function (number) {
      return '0' + `${number - 1}`;
    },
  },
  effect: "fade", 
  fadeEffect: {
    crossFade: true
  },
  speed: 1000,
  breakpoints: {
    750: {
      direction: "vertical",
      spaceBetween: 20,
      pagination: {
        renderFraction: function (currentClass, totalClass) {
          return '<span class="' + currentClass + '"></span>' +
            ' <span class="' + "top-about__partition" + '"></span> ' +
            '<span class="' + totalClass + '"></span>';
        }
      }
    }
  }
});